import React from 'react'
import { DentalBenefitsRoot, DentalBenefitsContainer } from './DentalBenefits.styles'
import { CopyColumnHeader } from '../../RawBenefits.styles'
import { ImageWithText } from 'components/Sections/ImageWithText'
import dentalImage from '../../../../../public/assets/home/home-hero.webp'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { Stack } from 'components/Stack'

export const DentalBenefits: React.FC = () => {
  const { t } = useTranslation()

  const DentalCopy = () => (
    <Stack gap='3' direction='column'>
      <CopyColumnHeader>{t('raw-benefits:dental-benefits.title')}</CopyColumnHeader>

      <Text>{t('raw-benefits:dental-benefits.body.0')}</Text>
      <Text>{t('raw-benefits:dental-benefits.body.1')}</Text>
    </Stack>
  )

  return (
    <DentalBenefitsRoot>
      <DentalBenefitsContainer>
        <ImageWithText
          copyColumn={<DentalCopy />}
          imageSrc={dentalImage}
          imageAlt="raw-benefits:dental-benefits.image-alt"
          imageSide="right"
          isMobileImageBottom
        />
      </DentalBenefitsContainer>
    </DentalBenefitsRoot>
  )
}

DentalBenefits.displayName = 'DentalBenefits'
